import { defineType } from "sanity";

export default defineType({
  name: "expeditionInclusionModal",
  type: "document",
  title: "Expedition Inclusion Modal",
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString",
      options: { collapsible: false }
    },
    {
      name: "description",
      title: "Description",
      type: "multilingualArrayBlockContent",
      options: { collapsible: false }
    },
    {
      name: "inclusions",
      title: "Inclusions",
      type: "array",
      of: [{ type: "expeditionInclusionModalItem" }]
    },
    {
      name: "link",
      title: "Link",
      type: "reference",
      to: [{ type: "page" }]
    }
  ],
  preview: {
    select: {},
    prepare() {
      return {
        title: "Expedition Inclusion Modal"
      };
    }
  }
});
